import { LockClosedIcon, ReloadIcon, UpdateIcon } from '@radix-ui/react-icons'
import { TooltipWrapper } from 'components/TooltipWrapper'
import { useGeckoAnalytics } from 'features/analytics'
import { useKestrelViewerContext } from 'features/kestrelViewer/types/KestrelViewerInterfaces'
import { ViewToggle } from 'features/kestrelViewer/ui/tools/ViewToggle'
import React, { FC } from 'react'
import { KVNavigationMode } from 'types'

export const NavigationModes: FC = () => {
  const { sendCommand, navigationMode, setNavigationMode } =
    useKestrelViewerContext()
  const { trackButtonClicked } = useGeckoAnalytics()
  const { kestrelModel } = useKestrelViewerContext()

  const handleNavigationModeToggle = () => {
    let newMode: KVNavigationMode

    if (navigationMode === 'orbit') {
      newMode = 'fixedPivot'
    } else if (navigationMode === 'fixedPivot') {
      newMode = 'locked'
    } else if (navigationMode === 'locked') {
      newMode = 'orbit'
    } else {
      newMode = 'orbit'
    }

    setNavigationMode(newMode)

    sendCommand({
      command: 'setNavigationMode',
      navigationMode: newMode,
    })

    trackButtonClicked({
      button_name: 'kestrel_set_navigation_mode',
      kestrel_model_id: kestrelModel?.data.kestrel_model_id,
      navigation_mode: newMode,
    })
  }

  const getTooltipLabel = () => {
    switch (navigationMode) {
      case 'orbit':
        return 'Orbit Mode'
      case 'fixedPivot':
        return 'Pivot Mode'
      case 'locked':
        return 'Locked Mode'
      default:
        return 'Navigation Mode'
    }
  }

  const renderIcon = () => {
    const iconProps = {
      style: {
        color: 'white',
        transition: 'color 0.2s ease-in-out',
      },
      width: 22,
      height: 22,
    }

    switch (navigationMode) {
      case 'orbit':
        return <ReloadIcon {...iconProps} />
      case 'fixedPivot':
        return <UpdateIcon {...iconProps} />
      case 'locked':
        return <LockClosedIcon {...iconProps} />
      default:
        return <ReloadIcon {...iconProps} />
    }
  }

  return (
    <TooltipWrapper side={'right'} offset={5} label={getTooltipLabel()}>
      <ViewToggle onClick={handleNavigationModeToggle}>
        {renderIcon()}
      </ViewToggle>
    </TooltipWrapper>
  )
}
